
















import { Component, Mixins } from 'vue-property-decorator'
import StudyResultAnswers from '@/components/common/organisms/StudyResultAnswers.vue'
import StudyResultApis, { StudyResultData } from '@/mixins/requests/student/StudyResultApis.vue'
import ButtonBase from '@/components/common/atoms/ButtonBase.vue'
import CookieMethods from '@/mixins/CookieMethods.vue'

@Component({
  components: {
    StudyResultAnswers,
    ButtonBase,
  },
})
export default class StudentStudyResult extends Mixins(StudyResultApis, CookieMethods) {
  private studyResultData: StudyResultData | null = null

  private async mounted() {
    this.studyResultData = await this.getStudyResultData()
  }

  private async logout() {
    await this.resetAuthAcbt()
    this.$router.push({ name: 'StudentLogin' })
  }

  private async problemCheck() {
    window.open('/dummy/practice/pdf/problem_check.pdf', '_blank')
  }
}
